import { useEffect, useState } from 'react';

export function SWCacheManager() {
  const [swStatus, setSwStatus] = useState<'checking' | 'active' | 'error' | 'none'>('checking');
  const [cacheSize, setCacheSize] = useState<number>(0);

  useEffect(() => {
    checkServiceWorkerStatus();
    checkCacheSize();
  }, []);

  const checkServiceWorkerStatus = async () => {
    try {
      if ('serviceWorker' in navigator) {
        const registration = await navigator.serviceWorker.getRegistration();
        if (registration) {
          setSwStatus('active');
        } else {
          setSwStatus('none');
        }
      } else {
        setSwStatus('error');
      }
    } catch (error) {
      console.error('Erro ao verificar Service Worker:', error);
      setSwStatus('error');
    }
  };

  const checkCacheSize = async () => {
    try {
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        let totalSize = 0;
        
        for (const cacheName of cacheNames) {
          const cache = await caches.open(cacheName);
          const keys = await cache.keys();
          totalSize += keys.length;
        }
        
        setCacheSize(totalSize);
      }
    } catch (error) {
      console.error('Erro ao verificar tamanho do cache:', error);
    }
  };

  const clearAllCaches = async () => {
    try {
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(
          cacheNames.map(cacheName => caches.delete(cacheName))
        );
        setCacheSize(0);
        console.log('Cache limpo com sucesso!');
      }
    } catch (error) {
      console.error('Erro ao limpar cache:', error);
    }
  };

  const unregisterServiceWorker = async () => {
    try {
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(
          registrations.map(registration => registration.unregister())
        );
        setSwStatus('none');
        console.log('Service Worker removido com sucesso!');
      }
    } catch (error) {
      console.error('Erro ao remover Service Worker:', error);
    }
  };

  // Só mostrar em desenvolvimento
  if (import.meta.env.PROD) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 bg-white border border-gray-300 rounded-lg p-4 shadow-lg z-50 max-w-sm">
      <h3 className="font-semibold text-sm mb-2">Service Worker Status</h3>
      <div className="space-y-2 text-xs">
        <div>
          <span className="font-medium">Status:</span> 
          <span className={`ml-2 px-2 py-1 rounded text-xs ${
            swStatus === 'active' ? 'bg-green-100 text-green-800' :
            swStatus === 'error' ? 'bg-red-100 text-red-800' :
            swStatus === 'none' ? 'bg-gray-100 text-gray-800' :
            'bg-yellow-100 text-yellow-800'
          }`}>
            {swStatus}
          </span>
        </div>
        <div>
          <span className="font-medium">Cache entries:</span> {cacheSize}
        </div>
        <div className="flex space-x-2">
          <button
            onClick={clearAllCaches}
            className="px-2 py-1 bg-blue-500 text-white rounded text-xs hover:bg-blue-600"
          >
            Limpar Cache
          </button>
          <button
            onClick={unregisterServiceWorker}
            className="px-2 py-1 bg-red-500 text-white rounded text-xs hover:bg-red-600"
          >
            Remover SW
          </button>
        </div>
      </div>
    </div>
  );
}
